// Lazy window globals for the read models that publishGlobals exposes (vouchers, VAT,
// reports, payroll, ...). They used to be derived eagerly on every state change, even
// when no screen read them; the trial balance alone builds full postings for every
// voucher twice. A lazy global is computed on its first read after a publish and cached
// until the next publish, so an edit that no visible screen depends on costs nothing.
//
// Plain assignment (`window.EMPLOYEES = rows`) still works: it overrides the value until
// the next publish, which is what the old data property did as well.
(function () {
  const slots = new Map();
  const defined = new Set();

  const define = (key) => {
    if (defined.has(key)) return;
    defined.add(key);
    Object.defineProperty(window, key, {
      configurable: true,
      enumerable: true,
      get() {
        const slot = slots.get(key);
        if (!slot) return undefined;
        if (!slot.done) {
          slot.value = slot.compute();
          slot.done = true;
          slot.compute = null;
        }
        return slot.value;
      },
      set(value) {
        slots.set(key, { done: true, value, compute: null });
      },
    });
  };

  // `computeByKey` maps a global name to a zero-argument function. Every key is
  // replaced at once, so no global can mix values from two different states.
  const publish = (computeByKey) => {
    Object.keys(computeByKey).forEach((key) => {
      define(key);
      slots.set(key, { done: false, value: undefined, compute: computeByKey[key] });
    });
  };

  // Shares one derivation between several globals (one deriveReports call for CHART,
  // RESULT and TRIAL_BALANCE would otherwise run three times). A throwing build is not
  // cached, so the next read retries it.
  const once = (build) => {
    let done = false;
    let value;
    return () => {
      if (!done) {
        value = build();
        done = true;
      }
      return value;
    };
  };

  window.PlummeLazyGlobals = { publish, once };
})();
